import api from '@/services/Api';

export default {
    getPills(){
        return api.get('/api/v1/knowledge/pills')
    },
    getPill(slug){
        return api.get('/api/v1/knowledge/pill/'+slug)
    },
    getScores(){
        return api.get('/api/v1/knowledge')
    }
}